import styled from 'styled-components'
import Markdown from 'react-markdown'

const StyledText = styled.div`
    color: ${ props => props.theme.colors[props.color] };
    display: flex;
    justify-content: center;
    flex-direction: column;

    font-family: "Atkinson Hyperlegible Mono", serif;
    font-optical-sizing: auto;
    font-weight: ${ props => props.bold ? '900' : 'normal' };
    font-style: normal;

    @media print {
        line-height: 1.45;

        p {
            margin: 0.5em;
        }
    }

    ${ props => props.s }
`

export const Text = ({ children, color='black', bold=false, style={} }) => <StyledText
    style={ style }
    color={ color }
    bold={ bold }
>
    <Markdown breaks>{ children }</Markdown>
</StyledText>
